import * as React from 'react';
import CircularProgress from '@mui/material/CircularProgress';

const LoadingIndicator = () => {
    return (
        <div
            data-testid="loading-indicator"
            style={{
                position: "fixed",       // stays on top of everything
                top: 0,
                left: 0,
                width: "100vw",
                height: "100vh",
                background: "rgba(255, 255, 255, 0.7)", // semi-transparent backdrop
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                zIndex: 1300, // higher than MUI drawers/appbar
            }}
        >
            {/* gradient definition */}
            <svg width={0} height={0}>
                <defs>
                    <linearGradient id="my_gradient" x1="0%" y1="0%" x2="0%" y2="100%">
                        <stop offset="0%" stopColor="#e01cd5" />
                        <stop offset="100%" stopColor="#1CB5E0" />
                    </linearGradient>
                </defs>
            </svg>

            {/* progress spinner */}
            <CircularProgress
                size={80}
                thickness={5}
                sx={{ 'svg circle': { stroke: 'url(#my_gradient)' } }}
            />
        </div>
    );
};

export default LoadingIndicator;
